var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLScalarType, Kind } from "graphql";
import { GraphQLLocalDate, GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, Float, InputType, ObjectType } from "type-graphql";
import { InvalidArgumentError } from "../../error/direct.js";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { BatchType } from "../resources/DailyDepartmentNotification.js";
import { FundraisingEntryNode } from "../resources/Fundraising.js";
import { GlobalIdScalar, isGlobalId, parseGlobalId, } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListFundraisingEntriesArgs = class ListFundraisingEntriesArgs extends FilteredListQueryArgs("FundraisingEntryResolver", [
    "donatedOn",
    "amount",
    "amountUnassigned",
    "donatedTo",
    "donatedBy",
    "batchType",
    "createdAt",
    "updatedAt",
    "solicitationCode",
    "solicitationCodeTags",
]) {
};
ListFundraisingEntriesArgs = __decorate([
    ArgsType()
], ListFundraisingEntriesArgs);
export { ListFundraisingEntriesArgs };
let ListFundraisingEntriesResponse = class ListFundraisingEntriesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [FundraisingEntryNode], { nullable: false }),
    __metadata("design:type", Array)
], ListFundraisingEntriesResponse.prototype, "data", void 0);
ListFundraisingEntriesResponse = __decorate([
    ObjectType("ListFundraisingEntriesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListFundraisingEntriesResponse);
export { ListFundraisingEntriesResponse };
let SetFundraisingEntryInput = class SetFundraisingEntryInput {
    notes;
    solicitationCodeOverrideId;
    amountOverride;
    donatedOnOverride;
    donatedToOverride;
    donatedByOverride;
    batchTypeOverride;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], SetFundraisingEntryInput.prototype, "notes", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], SetFundraisingEntryInput.prototype, "solicitationCodeOverrideId", void 0);
__decorate([
    Field(() => Float, { nullable: true }),
    __metadata("design:type", Number)
], SetFundraisingEntryInput.prototype, "amountOverride", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], SetFundraisingEntryInput.prototype, "donatedOnOverride", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], SetFundraisingEntryInput.prototype, "donatedToOverride", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], SetFundraisingEntryInput.prototype, "donatedByOverride", void 0);
__decorate([
    Field(() => BatchType, { nullable: true }),
    __metadata("design:type", String)
], SetFundraisingEntryInput.prototype, "batchTypeOverride", void 0);
SetFundraisingEntryInput = __decorate([
    InputType("SetFundraisingEntryInput")
], SetFundraisingEntryInput);
export { SetFundraisingEntryInput };
const solicitationCodeRegex = /^(?<prefix>[A-Za-z]{2})(?<code>\d{4,})$/;
const SolicitationCodeUpsertScalar = new GraphQLScalarType({
    name: "SolicitationCodeUpsert",
    description: "Either the global id of a solicitation code or a string to create a new one",
    parseValue(value) {
        if (typeof value === "string") {
            const match = solicitationCodeRegex.exec(value);
            if (match?.groups?.prefix && match.groups.code) {
                return {
                    prefix: match.groups.prefix,
                    code: Number.parseInt(match.groups.code, 10),
                };
            }
            const globalId = parseGlobalId(value);
            if (globalId.isOk()) {
                return globalId.value;
            }
        }
        throw new InvalidArgumentError("Invalid solicitation code");
    },
    serialize(value) {
        return isGlobalId(value)
            ? GlobalIdScalar.serialize(value)
            : `${value.prefix}${value.code}`;
    },
    parseLiteral(ast) {
        if (ast.kind === Kind.STRING) {
            return this.parseValue(ast.value);
        }
        throw new InvalidArgumentError("Invalid solicitation code");
    },
});
let CreateFundraisingEntryInput = class CreateFundraisingEntryInput {
    solicitationCodeId;
    amount;
    donatedOn;
    donatedTo;
    donatedBy;
    batchType;
    notes;
};
__decorate([
    Field(() => SolicitationCodeUpsertScalar, { nullable: false }),
    __metadata("design:type", Object)
], CreateFundraisingEntryInput.prototype, "solicitationCodeId", void 0);
__decorate([
    Field(() => Float, { nullable: false }),
    __metadata("design:type", Number)
], CreateFundraisingEntryInput.prototype, "amount", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], CreateFundraisingEntryInput.prototype, "donatedOn", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], CreateFundraisingEntryInput.prototype, "donatedTo", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], CreateFundraisingEntryInput.prototype, "donatedBy", void 0);
__decorate([
    Field(() => BatchType, { nullable: false }),
    __metadata("design:type", String)
], CreateFundraisingEntryInput.prototype, "batchType", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], CreateFundraisingEntryInput.prototype, "notes", void 0);
CreateFundraisingEntryInput = __decorate([
    InputType("CreateFundraisingEntryInput")
], CreateFundraisingEntryInput);
export { CreateFundraisingEntryInput };
//# sourceMappingURL=ListFundraisingEntriesResponse.js.map